import { TSendRegistrationEmailParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const sendRegistrationEmail = async (
  params: TSendRegistrationEmailParams
) => {
  const { userId } = params;

  await m8API.auth.reSendRegistrationConfirmationEmail({ idUser: userId });
};
